export enum Permissions {
  LIST = 'LIST',
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  ACTIVATE = 'ACTIVATE',
  DEACTIVATE = 'DEACTIVATE',
  APPROVE = 'APPROVE',
  PAYMENT = 'PAYMENT',
  REMUNERATION = 'REMUNERATION',
  DOWNLOAD = 'DOWNLOAD',
  PROCESS = 'PROCESS',
  PROCEEDEMI = 'PROCEEDEMI',
}

export enum PermissionLevels {
  TRACKS = 'track',
  PLATFORM = 'platform',
  EXAMS = 'exam',
  JOBS = 'job',
  QUESTION_COLLECTIONS = 'questioncollection',
  QUESTIONS = 'question',
  QUESTIONS_MAPPING = 'questionmapping',
  REPORTED_QUESTIONS = 'questionreport',
  APPEALED_QUESTIONS = 'appealedquestion',
  EXPIRED_QUESTIONS = 'expiredquestion',
  STUDY_CARD_PACKS = 'studycardpack',
  STUDY_CARD_STACKS = 'studycardstack',
  STUDY_CARD_CARDS = 'studycardcard',
  DISCUSS = 'discuss',
  VIDEOS = 'video',
  VIDEO_PACKS = 'video_pack',
  VIDEO_QA = 'videoqa',
  VIDEO_PACK_SORTING = 'video_pack_sorting',
  HD_VIDEOS = 'hd_videos',
  PACKS = 'pack',
  COURSE_MANAGEMENT = 'coursemanagement',
  TEST_SERIES = 'testseries',
  QUIZ = 'quiz',
  MOCK = 'mockpull',
  SCREENLET = 'screenlet',
  PLAYLIST = 'playlist',
  SUBJECT = 'subject',
  MODULE = 'module',
  TOPIC = 'topic',
  DAILYSTUDYPLAN = 'dailystudyplan',
  FREETRIALSTUDYPLAN = 'freetrialstudyplan',
  ONBOARDINGQUESTION = 'onboardingquestion',
  PRODUCTPACKAGE = 'productpackage',
  PLAN = 'plan',
  GOLDPROGRAM = 'goldprogram',
  PURCHASE = 'purchase',
  TEACHERS = 'teacher',
  PROFILE = 'profile',
  ELEVATE_MENTOR = 'elevate-mentor',
  ELEVATE_LIVE_CLASS = 'elevateliveclass',
  ELEVATE_PURCHASE = 'elevatepurchase',
  LANDING_PAGE = 'landingpage',
  ELEVATE = 'elevate',
  BATCH = 'batch',
  CHATGROUP = 'chatgroup',
  CHATBOT = 'chatbot',
  LIVECLASS_REMUNERATION = 'facultylivedetails',
  NEW_ELEVATE_BATCH_REPORT = 'newElevateBatchReport',
  USER_STATUS = 'userStatusFlag',
  BATCH_START_DATE = 'batchstartdate',
  VALIDITY_EXTENSION = 'validityextension',
  BUSINESS_HIERARCHY = 'businesshierarchy',
  REVIEWER_DASHBOARD = 'elevatetaskattemptreview',
  ELEVATE_ASSIGNMENT_MANAGEMENT = 'assignment',
  ELEVATE_ASSIGNMENT_TEMPLATE = 'assignmenttemplate',
  ELEVATE_LIVE_CLASS_TEMPLATE = 'liveclasstemplate',
  NSDC_ACCREDITATION_RECORD = 'nsdcaccreditationrecord',
  NSDC_EXAM = 'nsdcExam',
  NON_ELEVATE_COURSE_AI_CONTENT = "aicontentmappinggoldandregularcourse",
  NON_ELEVATE_BATCH_AI_CONTENT = "aicontentmappinggoldandregularbatchonly",
  ELEVATE_COURSE_AI_CONTENT = "aicontentmappingelevatecourse",
  ELEVATE_BATCH_AI_CONTENT = "aicontentmappingelevatebatchonly",
  CAMPAIGN_URLS = 'campaignurl',
  REFUND_REQUEST = 'refundrequest',
  SERVICE_REQUEST = 'servicerequest',
  DO_NOT_DISTURB = 'donotdisturb',
  OPS_CONSOLE = 'opsconsole',
  MOCK_INTERVIEWER = 'mockinterviewer',
  ENDED_LIVE_CLASS = 'endedliveclass',
  CONTENT_PARTNER = 'contentpartner',
  GROUP = 'group',
  PERMISSION = 'permission',
}

export type ViewPermissions = {
  [p in PermissionLevels]?: boolean
}

export type PermissionLevelsMap = {
  [p in PermissionLevels]?: Permissions[]
}

export interface AccessControls {
  viewPermissions: ViewPermissions
  permissionLevels?: PermissionLevelsMap | undefined
}
export interface AccessControlsResponse {
  resource: PermissionLevels
  permissions: Permissions[]
}
